module.exports = __webpack_public_path__ + "img/karagandy1.1f8ff9d1.jpg";